import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { UnderlineTabs } from '@root/shared/ui-kit'

import type { PortDrawerTab } from '../../atoms/reatom-port-wallets'
import type { ClassNameProps } from '@root/shared/react'

type PortWalletsDrawerTabsProps = {
  tab: PortDrawerTab
  setTab: (value: PortDrawerTab) => void
  onOpenChange?: (open: boolean) => void
} & ClassNameProps

export const PortWalletsDrawerTabs: React.FC<PortWalletsDrawerTabsProps> = ({
  className,
  tab,
  setTab,
}) => {
  const { t } = useTranslation()

  return (
    <Root
      className={className}
      onChange={(value) => setTab(value as PortDrawerTab)}
      value={tab}
    >
      <UnderlineTabs.Tab value={'export' satisfies PortDrawerTab}>
        {t('wallet-tracker.port.tab.export')}
      </UnderlineTabs.Tab>
      <UnderlineTabs.Tab value={'import' satisfies PortDrawerTab}>
        {t('wallet-tracker.port.tab.import')}
      </UnderlineTabs.Tab>
    </Root>
  )
}

const Root = styled(UnderlineTabs<PortDrawerTab>)`
  --tab-padding-inline: 10px;

  justify-content: start;
  margin-top: 4px;
  padding-inline: 14px;

  button {
    > div {
      bottom: -2px;
    }
  }
`
